import { useSelector } from "react-redux";
import { selectInscribedSubjects } from "../../reduxSlices/subjectsSlice";
import "./MobileNav.css";
import { Link } from "react-router-dom";
import Translatable from "../Translatable/Translatable";

const MobileNav = () => {
  const inscribedSubjects = useSelector(selectInscribedSubjects);
  return (
    <div className="mobile-nav">
      <h2 className="mobile-inscripciones-title">
        <Translatable as="span" capitalize>Inscripciones</Translatable>
      </h2>
      <Link to="/mis-cursos" className="mobile-nav-link">
        <Translatable as="span" capitalize>Mis cursos</Translatable> <span>{!inscribedSubjects ? 0 : inscribedSubjects.length}</span>
      </Link>
    </div>
  );
};

export default MobileNav;
